import Sidebar from '@/components/Sidebar';
import { Outlet } from 'react-router-dom';

export default function DashboardLayout() {
  return (
    <div className="flex h-screen bg-slate-50">
      <Sidebar />
      <main className="flex-1 overflow-y-auto" data-testid="main-content">
        <Outlet />
      </main>
    </div>
  );
}
